import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { Rocket } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import { getStoredFunMode, translate } from '../i18n';

export const deploymentsRouteRef = createRouteRef();

export const deploymentsPage = PageBlueprint.make({
  params: {
    path: '/deployments',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('deployments.page.title', getStoredFunMode()),
    icon: <Rocket size={20} strokeWidth={2} />,
    routeRef: deploymentsRouteRef,
    noHeader: true,
    loader: () =>
      import('./DeployManagementPage').then(m => (
        <PageShareTitle title="Deployments">
          <m.DeployManagementPage />
        </PageShareTitle>
      )),
  },
});

export const deploymentsPlugin = createFrontendPlugin({
  pluginId: 'deployments',
  extensions: [deploymentsPage],
});
